import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "login-view"
}
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = { class: "login-main" }
const _hoisted_4 = { class: "operations" }

import { onMounted, ref } from "vue";
import { http } from "@/main";
import { useRouter } from "vue-router";
import store from "@/store";
import { ElMessage } from "element-plus";
import { loadTranslations } from "@/composables/useTranslation";
import { loadProtocolText } from "@/composables/useProtocolText";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const username = ref<string>("");
const password = ref<string>("");
const router = useRouter();

const show = ref<boolean>(false);
const verifyToken = async () => {
  const result = await store.dispatch("auth/verifyToken");
  console.log(result);
  if (result) {
    router.push({ name: "overall" });
  }
  show.value = true;
};

const handleSubmit = async () => {
  try {
    const response = await http.post("/login", {
      username: username.value,
      password: password.value,
    });
    console.log(response.data);
    const token = response.data.token;
    store.commit("auth/setToken", token);
    store.dispatch("auth/verifyToken");
    // 登录态建立后加载翻译表/协议枚举缓存：
    // App 挂载发生在登录页阶段，彼时未登录，loadTranslations/loadProtocolText 已 401 失败，
    // 不在此补加载则登录后首次进入的页面设备名/枚举翻译为空（刷新后才能恢复）
    loadTranslations();
    loadProtocolText();
    router.push({ name: "overall" });
  } catch (err) {
    console.error(err);
    ElMessage.error("登陆失败，请检查你的用户名和密码");
  }
};
const forgetPassword = () => {
  router.push({ name: "resetPassword" });
};

onMounted(() => {
  verifyToken();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!

  return (show.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "login-header" }, [
            _createElementVNode("div", { class: "logo" }),
            _createElementVNode("p", null, "锐深科技云平台管理端")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "title item" }, "管理员登录", -1)),
            _createVNode(_component_el_input, {
              modelValue: username.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
              class: "item",
              placeholder: "请输入账号"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              modelValue: password.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
              class: "item",
              type: "password",
              placeholder: "请输入密码",
              onKeydown: _withKeys(handleSubmit, ["enter"])
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_link, {
                type: "info",
                onClick: forgetPassword
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("忘记密码", -1)
                ]))]),
                _: 1
              })
            ]),
            _createVNode(_component_el_button, {
              type: "primary",
              class: "item button",
              color: "#f332e3",
              onClick: handleSubmit
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" LOGIN ", -1)
              ]))]),
              _: 1
            }),
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "footer" }, [
              _createTextVNode(" COPYRIGHT © 2019-2026 深圳市锐深科技有限公司 版权所有 "),
              _createElementVNode("a", {
                class: "beian-link",
                href: "https://beian.miit.gov.cn",
                target: "_blank",
                rel: "noopener noreferrer"
              }, "粤ICP备17088454号-3")
            ], -1)),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "item" }, null, -1))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})